import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { refreshGauge, finishGaugingUp, changeRealMeter } from '../../actions/wallpapers'
import MeasureBackground from './../../components/MeasureBackground'

const getBackgroundIndex = state => dotProp.get(state, 'project.background.index', 0)

const mapStateToProps = state => ({
  index: dotProp.get(state, 'wallpapers.selectedIndex', 0),
  isCalibrationNow: dotProp.get(state, 'wallpapers.isGaugingNow', false),
  measurement: dotProp.get(state, `wallpapers.images.${getBackgroundIndex(state)}.calibration`, {
    perMeter: 0,
    realMeter: 100,
  }) || { perMeter: 0, realMeter: 100 },
  sidebarIsClosed: dotProp.get(state, 'sidebar.isClosed', false),
})

const mapDispatchToProps = dispatch => ({
  changeMeasurement: (index, perMeter) => dispatch(refreshGauge(index, perMeter)),
  changeRealMeter: (index, mes) => () => dispatch(changeRealMeter(index, mes)),
  accept: () => dispatch(finishGaugingUp(false, window.fetch)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MeasureBackground)



// WEBPACK FOOTER //
// ./src/containers/MeasureBackground/index.js